module.exports = __webpack_public_path__ + "static/media/Leanne S.6bf4fb5e.png";